import React from "react";
import { graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

// Import layout
import Layout from "../layouts/main";

// Import components
import SEO from "../components/seo";

// Import bootstrap
import { Button, Col, Container, Row } from "react-bootstrap";

// Import styles
import "./styles/teamMember.scss";
import "./styles/wp-styles.scss";
import "./styles/wpPost.css";

const TeamMember = ({ data, pageContext }) => {
  const { wpTeamMember } = data;
  const { previous, next } = pageContext;

  return (
    <Layout>
      <SEO
        title={wpTeamMember.seoFields.seo.title}
        description={wpTeamMember.seoFields.seo.description}
        image={wpTeamMember.featuredImage.node.sourceUrl}
      />
      <div className="team-member-template">
        <Container>
          <Row className="team-member-intro">
            <Col xs={12} md={5} lg={4} xl={3}>
              <GatsbyImage
                xs={12}
                md={5}
                className="image"
                image={
                  wpTeamMember.featuredImage.node.localFile.childImageSharp
                    .gatsbyImageData
                }
                alt="test"
              />
            </Col>
            <Col className="text" xs={12} md={7} lg={8} xl={9}>
              <h1 className="shout">{wpTeamMember.title}</h1>
              <div
                className="talk"
                dangerouslySetInnerHTML={{ __html: wpTeamMember.excerpt }}
              />
            </Col>
          </Row>
        </Container>
        <hr />
        <Container className="post-content">
          <div dangerouslySetInnerHTML={{ __html: wpTeamMember.content }} />
        </Container>
        <Container className="team-member-pagination">
          <ul>
            <li>
              {previous && (
                <Link to={`/about/${previous.slug}`} rel="prev">
                  <Button variant="accent">← Prev</Button>
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={`/about/${next.slug}`} rel="next">
                  <Button variant="accent">Next →</Button>
                </Link>
              )}
            </li>
          </ul>
        </Container>
      </div>
    </Layout>
  );
};

export default TeamMember;

export const query = graphql`
  query WpTeamMemberById($slug: String!) {
    wpTeamMember(slug: { eq: $slug }) {
      __typename
      content
      excerpt
      featuredImage {
        node {
          id
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: TRACED_SVG, formats: AUTO)
            }
          }
          sourceUrl
        }
      }
      id
      seoFields {
        seo {
          description
          title
        }
      }
      title
    }
  }
`;
